import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import transformObjectKeys from './mixins/transformObjectKeys'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
Vue.prototype.$http = axios
Vue.mixin(transformObjectKeys)

// hide errors in production
if (process.env.NODE_ENV === 'production') {
// eslint-disable-next-line handle-callback-err
  Vue.config.errorHandler = function (err, vm, info) {
  }
}

// axios.defaults.withCredentials = true

new Vue({
  router,
  store,
  vuetify,
  created () {
    const userInfo = localStorage.getItem('user')
    if (userInfo) {
      const userData = JSON.parse(userInfo)
      this.$store.commit('user/setUserData', userData)
    }
    this.$http.interceptors.response.use(
      response => response,
      error => {
        const response = error.response
        if (!response) {
          return Promise.reject(error)
        }
        if (response.status === 401 && error.config.url !== '/login') {
          this.$store.commit('user/clearUserData')
          this.$router.push({ name: 'login' })
        } else if (response.status >= 500 || response.status === 422) {
          this.$root.$emit('api-error', response)
        }
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')
